import { BenchmarkScale } from '@/lib/enums/bi-enums'
import { AnalyticsEvent } from './analyticsTracking'

export const analyticsTags: Record<string, AnalyticsEvent> = Object.freeze({
	login: {
		event: 'Login',
		login_to_application: 'success',
	},
	biTabCompanyPerformance: {
		event: 'BI Submenu Selection',
		bi_submenu_page: 'company_performance',
	},
	biTabListings: {
		event: 'BI Submenu Selection',
		bi_submenu_page: 'listings',
	},
	biTabTransactions: {
		event: 'BI Submenu Selection',
		bi_submenu_page: 'transactions',
	},
	biTabAgentProductivity: {
		event: 'BI Submenu Selection',
		bi_submenu_page: 'agent_productivity',
	},
	biRevSumYTD: {
		event: 'BI Revsum Timeframe',
		revsum_time_selection: 'year_to_date',
	},
	biRevSumLTM: {
		event: 'BI Revsum Timeframe',
		revsum_time_selection: 'last_12_months',
	},
	biRevSumPriorYear: {
		event: 'BI Revsum Timeframe',
		revsum_time_selection: 'prior_year',
	},
	biRevBreakdownDropdownYear1: {
		event: 'BI Revbreakdown Timeframe',
		revbreakdown_timeframe: '1',
	},
	biRevBreakdownDropdownYear2: {
		event: 'BI Revbreakdown Timeframe',
		revbreakdown_timeframe: '2',
	},
	biRevBreakdownDropdownYear3: {
		event: 'BI Revbreakdown Timeframe',
		revbreakdown_timeframe: '3',
	},
	biRevBreakdownDropdownYear4: {
		event: 'BI Revbreakdown Timeframe',
		revbreakdown_timeframe: '4',
	},
	biRevBreakdownDropdownYear5: {
		event: 'BI Revbreakdown Timeframe',
		revbreakdown_timeframe: '5',
	},
	biShowRevBreakdownTable: {
		event: 'BI Show Revbreakdown Table',
		show_revbreakdown_table: 'view_revbreakdown_table',
	},
	biHoverRevBreakdownGraph: {
		event: 'BI Hover Revbreakdown Graph',
		show_revbreakdown_graph_tooltip: 'view_revbreakdown_graph_tooltip',
	},
	biSelectDispCategoryClosedChecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'closed_checked',
	},
	biSelectDispCategoryClosedUnchecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'closed_unchecked',
	},
	biSelectDispCategoryOpenedChecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'opened_checked',
	},
	biSelectDispCategoryOpenedUnchecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'opened_unchecked',
	},
	biSelectDispCategoryPendingChecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'pending_checked',
	},
	biSelectDispCategoryPendingUnchecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'pending_unchecked',
	},
	biSelectDispCategoryOtherRevenueChecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'other_revenue_checked',
	},
	biSelectDispCategoryOtherRevenueUnchecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'other_revenue_unchecked',
	},
	biSelectDispCategoryYourGoalChecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'your_goal_checked',
	},
	biSelectDispCategoryYourGoalUnchecked: {
		event: 'BI Select Disp Category',
		graph_display_category_selection: 'your_goal_unchecked',
	},
	biYearChevronYear1: {
		event: 'BI Year Selection Chevron',
		select_year: '1',
	},
	biYearChevronYear2: {
		event: 'BI Year Selection Chevron',
		select_year: '2',
	},
	biYearChevronYear3: {
		event: 'BI Year Selection Chevron',
		select_year: '3',
	},
	biYearChevronYear4: {
		event: 'BI Year Selection Chevron',
		select_year: '4',
	},
	biYearChevronYear5: {
		event: 'BI Year Selection Chevron',
		select_year: '5',
	},
	biGraphSaveGoal: {
		event: 'BI Click Goal Setting Graph',
		goal_setting_action: 'save_goal_setting',
	},
	biGraphCancelGoal: {
		event: 'BI Click Goal Setting Graph',
		goal_setting_action: 'cancel_goal_setting',
	},
	biBannerSaveGoal: {
		event: 'BI Click Goal Setting Banner',
		goal_setting_action: 'save_goal_setting',
	},
	biBannerCancelGoal: {
		event: 'BI Click Goal Setting Banner',
		goal_setting_action: 'cancel_goal_setting',
	},
	biDismissGoalBannerTemp: {
		event: 'BI Dismiss Goal Setting Banner',
		goalbanner_dismissal_action: 'temporary',
	},
	biDismissGoalBannerPerm: {
		event: 'BI Dismiss Goal Setting Banner',
		goalbanner_dismissal_action: 'permanent',
	},
	biListingsYTD: {
		event: 'BI Listings Date Range',
		daterange_selection: 'year_to_date',
	},
	biListingsLTM: {
		event: 'BI Listings Date Range',
		daterange_selection: 'last_12_months',
	},
	biListingsAddedChecked: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_added_checked',
	},
	biListingsAddedUnchecked: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_added_unchecked',
	},
	biListingsPendingChecked: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_pending_checked',
	},
	biListingsPendingUnchecked: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_pending_unchecked',
	},
	biListingsVolume: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_volume',
	},
	biListingsCount: {
		event: 'BI Listings Chart Control',
		listing_chart_selection: 'listings_count',
	},
	biListingsBreakdownTable: {
		event: 'BI Listings Breakdown Table',
		show_listing_breakdown_table: 'view_listing_breakdown_table',
	},
	biListingsBreakdownTooltip: {
		event: 'BI Listings Breakdown Tooltip',
		show_listbreakdown_graph_tooltip: 'view_listbreakdown_graph_tooltip',
	},
	biListingsTablePendingChecked: {
		event: 'BI Listings Table Status',

		listing_table_status_selection: 'listings_pending_checked',
	},
	biListingsTablePendingUnchecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_pending_unchecked',
	},
	biListingsTablePrelistingChecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_prelisting_checked',
	},
	biListingsTablePrelistingUnchecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_prelisting_unchecked',
	},
	biListingsTableActiveChecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_active_checked',
	},
	biListingsTableActiveUnchecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_active_unchecked',
	},
	biListingsTableAllChecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_all_checked',
	},
	biListingsTableAllUnchecked: {
		event: 'BI Listings Table Status',
		listing_table_status_selection: 'listings_all_unchecked',
	},
	biListingsOffMarketCanceledChecked: {
		event: 'BI Off-Market Listings Status',
		offmarket_listing_status_selection: 'listings_canceled_checked',
	},
	biListingsOffMarketCanceledUnchecked: {
		event: 'BI Off-Market Listings Status',
		offmarket_listing_status_selection: 'listings_canceled_unchecked',
	},
	biListingsOffMarketExpiredChecked: {
		event: 'BI Off-Market Listings Status',
		offmarket_listing_status_selection: 'listings_expired_checked',
	},
	biListingsOffMarketExpiredUnchecked: {
		event: 'BI Off-Market Listings Status',
		offmarket_listing_status_selection: 'listings_expired_unchecked',
	},
	biListingsOffMarketWithdrawnChecked: {
		event: 'BI Off-Market Listings Status',
		offmarket_listing_status_selection: 'listings_withdrawn_checked',
	},
	biListingsOffMarketWithdrawnUnchecked: {
		event: 'BI Offmarket Listings Status',
		offmarket_listing_status_selection: 'listings_withdrawn_unchecked',
	},
	biListingsOffMarketAllChecked: {
		event: 'BI Offmarket Listings Status',
		offmarket_listing_status_selection: 'listings_all_checked',
	},
	biListingsOffMarketAllUnchecked: {
		event: 'BI Offmarket Listings Status',
		offmarket_listing_status_selection: 'listings_all_unchecked',
	},
	biGciTab: {
		event: 'BI Metric Selection',
		bi_metric_type: 'gci',
	},
	biSidesTab: {
		event: 'BI Metric Selection',
		bi_metric_type: 'sides',
	},
	biSalesVolumeTab: {
		event: 'BI Metric Selection',
		bi_metric_type: 'sales_volume',
	},
	biYtdSegment: {
		event: 'BI Daterange',
		daterange_selection: 'year_to_date',
	},
	biLtmSegment: {
		event: 'BI Daterange',
		daterange_selection: 'last_12_months',
	},
	biGraphHover: {
		event: 'BI Chart Hover Tooltip',
		charthover_tooltip_action: 'charthover_tooltip',
	},
	biGraphOpenHover: {
		event: 'BI Hover Comp Graph',
		comp_graph_tooltip_selection: 'Opened_compgraph_tooltip',
	},
	biGraphCloseHover: {
		event: 'BI Hover Comp Graph',
		comp_graph_tooltip_selection: 'Closed_compgraph_tooltip',
	},
	biShowAsTable: {
		event: 'BI Show Chart As Table',
		showchart_as_table_action: 'show_chart_as_table',
	},
	biHoverBarGraph: {
		event: 'BI Hover Bar Graph',
		show_bar_graph_tooltip: 'show_bar_graph_tooltip',
	},
	biShowGraphAsTable: {
		event: 'BI Show Graph As Table',
		show_graph_tableview: 'show_graph_tableview',
	},
	biOpenedCompTable: {
		event: 'BI Show Comp Graph As Table',
		chart_as_table: 'Opened_comp_table',
	},
	biClosedCompTable: {
		event: 'BI Show Comp Graph As Table',
		chart_as_table: 'Closed_comp_table',
	},
	mlsSearchFilterCta: {
		event: 'Agent Search Filter',
		filter_CTA: 'clicked_filterCTA',
	},
	listingsSearchFilterCta: {
		event: 'Listing Search Filter',
		filter_CTA: 'clicked_filterCTA',
	},
	performanceFilterCta: {
		event: 'Performance Filter',
		filter_CTA: 'clicked_filterCTA',
	},
	mlsSearchNoResultsUpdate: {
		event: 'Agent Search No Results',
		noresults_update: 'noresults_update',
	},
	filtersApplied: {
		event: 'Agent Search Filter',
		applied_filters: '',
	},
	filtersCleared: {
		event: 'Agent Search Filter',
		clear_filters: 'cleared_filters',
	},
	listingsFiltersApplied: {
		event: 'Listing Search Filter',
		applied_filters: '',
	},
	listingsFiltersCleared: {
		event: 'Listing Search Filter',
		clear_filters: 'cleared_filters',
	},
	performanceFiltersCleared: {
		event: 'Performance Filter',
		clear_filters: 'cleared_filters',
	},
	leftNavBI: { event: 'BI Left Navigation Menu Selection', nav_menus: 'bi' },
	leftNavRecruiting: {
		event: 'recruiting_nav',
	},
	leftNavAgentManagement: {
		event: 'agent_roster_nav',
	},
	leftNavLogout: {
		event: 'BI Left Navigation Menu Selection',
		nav_menus: 'logout',
	},
	leftNavCannyFeedback: {
		event: 'BI Left Navigation Menu Selection',
		nav_menus: 'Feedback',
	},
	leftNavExpand: {
		event: 'BI Left Navigation Expand',
		nav_toggle: 'expand',
	},
	leftNavCollapse: {
		event: 'BI Left Navigation Collapse',
		nav_toggle: 'collapse',
	},
	biOrSwitchOn: {
		event: 'BI Toggle Show Other Revenue',
		show_other_revenue: 'other revenue_On',
	},
	biOrSwitchOff: {
		event: 'BI Toggle Show Other Revenue',
		show_other_revenue: 'other revenue_Off',
	},
	benchmarkChecked: {
		event: 'BI Click Config Benchmark',
		show_benchmark: 'benchmark_on',
	},
	benchmarkUnchecked: {
		event: 'BI Click Config Benchmark',
		show_benchmark: 'benchmark_off',
	},
	peerGroupLessThan1M: {
		event: 'BI Select Benchmark Peer Group',
		gci_peer_group_scale: 'below_1m',
	},
	peerGroupUpto5M: {
		event: 'BI Select Benchmark Peer Group',
		gci_peer_group_scale: '1m_to_4.9m',
	},
	peerGroupUpto10M: {
		event: 'BI Select Benchmark Peer Group',
		gci_peer_group_scale: '5m_to_9.9m',
	},
	peerGroupUpto20M: {
		event: 'BI Select Benchmark Peer Group',
		gci_peer_group_scale: '10m_to_19.9m',
	},
	peerGroupMoreThan20M: {
		event: 'BI Select Benchmark Peer Group',
		gci_peer_group_scale: 'above_20m',
	},
	prospectProfileClosedVolumeSelect: {
		event: 'Prospect Profile',
		trend_graph: 'closed_volume_graph',
	},
	prospectProfileClosedSidesSelect: {
		event: 'Prospect Profile',
		trend_graph: 'closed_sides_graph',
	},
	prospectProfileClosedVolumeHover: {
		event: 'Prospect Profile',
		trend_graph: 'closed_volume_hover',
	},
	prospectProfileClosedSidesHover: {
		event: 'Prospect Profile',
		trend_graph: 'closed_sides_hover',
	},
	prospectProfileClosedVolumeGraphAsTable: {
		event: 'Prospect Profile',
		trend_graph: 'chart_as_table_vol',
	},
	prospectProfileClosedSidesGraphAsTable: {
		event: 'Prospect Profile',
		trend_graph: 'chart_as_table_sides',
	},
	prospectProfileBothSidesSelect: {
		event: 'Prospect Profile',
		profile_production: 'both',
	},
	prospectProfileListSidesSelect: {
		event: 'Prospect Profile',
		profile_production: 'list',
	},
	prospectProfileBuySidesSelect: {
		event: 'Prospect Profile',
		profile_production: 'buy',
	},
	prospectProfileLtmTimePeriodSelect: {
		event: 'Prospect Profile',
		profile_production: 'perf_ltm',
	},
	prospectProfileYtdTimePeriodSelect: {
		event: 'Prospect Profile',
		profile_production: 'perf_ytd',
	},
	prospectProfileL5yTimePeriodSelect: {
		event: 'Prospect Profile',
		profile_production: 'perf_l5y',
	},
	// event change

	biTransactionsYTD: {
		event: 'BI Transactions Daterange',
		daterange_selection: 'year_to_date',
	},
	biTransactionsLTM: {
		event: 'BI Transactions Daterange',
		daterange_selection: 'last_12_months',
	},
	// event change

	biTransactionsSideBuy: {
		event: 'BI Transactions Sides',
		side_selection: 'Buy',
	},
	biTransactionsSideSell: {
		event: 'BI Transactions Sides',
		side_selection: 'Sell',
	},
	biTransactionsSideBuySell: {
		event: 'BI Transactions Sides',
		side_selection: 'Buy_Sell',
	},
	// event change

	biTransactionsChartStatusOpened: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'status_opened',
	},
	biTransactionsChartStatusPending: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'status_pending',
	},
	biTransactionsChartStatusClosed: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'status_closed',
	},
	biTransactionsChartMetricsGCI: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_GCI',
	},
	biTransactionsChartMetricsSides: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_sides',
	},
	biTransactionsChartMetricsSalesVolume: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_salesvolume',
	},
	biTransactionsChartMetricsABCR: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_ABCR',
	},
	biTransactionsChartMetricsAvgSalePrice: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_avg_saleprice',
	},
	biTransactionsChartMetricsTxnCount: {
		event: 'BI Transactions Chart Control',
		transaction_chart_selection: 'metrics_txn_count',
	},
	// event change

	biTransactionsBreakdownGCITable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_GCI_txnbreakdown_table',
	},
	biTransactionsBreakdownSidesTable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_sides_txnbreakdown_table',
	},
	biTransactionsBreakdownSalesVolumeTable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_salesvolume_txnbreakdown_table',
	},
	biTransactionsBreakdownABCRTable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_ABCR_txnbreakdown_table',
	},
	biTransactionsBreakdownAVGSALEAMTable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_avgsp_txnbreakdown_table',
	},
	biTransactionsBreakdownTRXCTTable: {
		event: 'BI Transactions Breakdown Table',
		show_transactions_breakdown_table: 'view_txncount_txnbreakdown_table',
	},
	// event change

	biHoverTxnBreakdownGCIGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_GCI_txnbreakdown_tooltip',
	},
	biHoverTxnBreakdownSidesGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_sides_txnbreakdown_tooltip',
	},
	biHoverTxnBreakdownSalesVolumeGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_salesvolume_txnbreakdown_tooltip',
	},
	biHoverTxnBreakdownABCRGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_ABCR_txnbreakdown_tooltip',
	},
	biHoverTxnBreakdownAVGSPGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_avgsp_txnbreakdown_tooltip',
	},
	biHoverTxnBreakdownTxnCountGraph: {
		event: 'BI Hover Txn BreakdownGraph',
		show_txnbreakdown_graph_tooltip: 'view_txncount_txnbreakdown_tooltip',
	},
	// event change
	biTransactionsTablePendingChecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_pending_checked',
	},
	biTransactionsTablePendingUnchecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_pending_unchecked',
	},
	biTransactionsTableClosedChecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_closed_checked',
	},
	biTransactionsTableClosedUnchecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_closed_unchecked',
	},
	biTransactionsTableAllChecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_all_checked',
	},
	biTransactionsTableAllUnchecked: {
		event: 'BI Transactions Table Status',
		txn_table_status_selection: 'transactions_all_unchecked',
	},
	// event change
	biTransactionsTxnBannerDismissal: {
		event: 'BI Txn Banner Dismissal',
		txnbanner_click_close_button: 'txn_banner_dismissed',
	},
	// event change
	biTransactionsTxnBannerRedirect: {
		event: 'BI Txn Banner Redirect Table',
		txnbanner_click_tableredirect_button: 'txntable_redirected',
	},
	// event change
	biViewTermsAndConditions: {
		event: 'BI View Terms and Conditions',
		click_terms_conditions: 'show_terms_conditions',
	},
	performanceSelectOffice: {
		event: 'Office Selection From Company Performance',
	},
	listingsSelectOffice: {
		event: 'Office Selection From Listings',
	},
	transactionsSelectOffice: {
		event: 'Office Selection From Transactions',
	},

	biMultiBrandSelection: {
		event: 'BI Multi Brand Selection',
	},
	biAgentDateRangeSelect: {
		event: 'BI Agent Productivity Date Range',
	},
	biAgentProductivityMetricSelection: {
		event: 'BI Agent Productivity Metric Selection',
	},
	biMultiCompanySelection: {
		event: 'BI Multi Company Selection',
	},
	biLogoutConfirmationFromLogoutPopup: {
		click_logout: 'confirmed_logout',
	},
	biLogoutCancelledFromLogoutPopup: {
		click_logout: 'cancelled_logout',
	},
	biProceedFromMultiCompany: {
		event: 'BI Proceed From Multi Company',
		click_continue: 'redirected_to_application',
	},
	biAIAssistedChatButton: {
		event: 'BI Click AI Assisted Chat Button',
		click_ai_chat_button: 'clicked_ai_chat_button',
	},
	biAgentProductivityAllAgents: {
		event: 'BI Agent Productivity Agentype',
		agent_type_selection: 'all_agents',
	},
	biAgentProductivityProducingAgents: {
		event: 'BI Agent Productivity Agentype',
		agent_type_selection: 'producing_agents_only',
	},
	biAgentRetentionGraphShowTable: {
		event: 'BI Agent Retention Table',
		click_agent_retention_table: 'view_agent_retention_table',
	},
	biAgentRetentionGraphToolTip: {
		event: 'BI Agent Retention  Graph Tooltip',
		hover_agent_retention_tooltip: 'view_agent_retention_graph_tooltip',
	},
	biAIAssistedCategorySelection: {
		event: 'Select Category From AI Chat',
	},
	biAIAssistedSuggestMoreQuestions: {
		event: 'Click Suggest More Questions button',
		click__suggest_more_question: 'viewed_additional_question',
	},
	biAIAssistedPrivacyNoticeURL: {
		event: 'Click Privacy Notice On AI Chat',
		click_privacy_notice: 'clicked_privacy_notice',
	},
	agentProfileNetRevenueTooltip: {
		event: 'Net revenue tooltip',
		click_agent_profile_net_revenue_tooltip: 'agent_net_revenue_score_tooltip',
	},
})

export const radioAnalyticsEvents = {
	[BenchmarkScale.LessThan1M]: analyticsTags.peerGroupLessThan1M,
	[BenchmarkScale.Upto5M]: analyticsTags.peerGroupUpto5M,
	[BenchmarkScale.Upto10M]: analyticsTags.peerGroupUpto10M,
	[BenchmarkScale.Upto20M]: analyticsTags.peerGroupUpto20M,
	[BenchmarkScale.MoreThan20M]: analyticsTags.peerGroupMoreThan20M,
}

export const biRevBreakdownDropdownYearEvents: AnalyticsEvent[] = [
	analyticsTags.biRevBreakdownDropdownYear1,
	analyticsTags.biRevBreakdownDropdownYear2,
	analyticsTags.biRevBreakdownDropdownYear3,
	analyticsTags.biRevBreakdownDropdownYear4,
	analyticsTags.biRevBreakdownDropdownYear5,
]

export const biRevBreakdownChevronYearEvents: AnalyticsEvent[] = [
	analyticsTags.biYearChevronYear1,
	analyticsTags.biYearChevronYear2,
	analyticsTags.biYearChevronYear3,
	analyticsTags.biYearChevronYear4,
	analyticsTags.biYearChevronYear5,
]

export const trackLoginEvent = (
    authorized: boolean
): AnalyticsEvent => { 
    return {
        ...analyticsTags.login,
        authorized: authorized ? 'true' : 'false',
    }
}
